import { useMemo } from "react";
import { PaymentService } from "@propertelligent/client-api";
import { infiniteScrollHook } from "../../hooks/infiniteScrollHook";
import useInfiniteScroll from "react-infinite-scroll-hook";

export const usePayments = (enabled: boolean, filter: string, tenantId?: number, isContractor?: boolean) => {
  const { rows, loading, hasMore, fetchData, currentPage } = infiniteScrollHook(
    {
      httpFetchDataFn: enabled
        ? isContractor
          ? PaymentService.getApiPaymentDueAccountContractorlist
          : PaymentService.getApiPaymentDueAccountTenantlist
        : () => Promise.resolve({ data: [] }),
      isDependentEntity: enabled,
      parentEntityId: tenantId,
    }
  );

  const filteredRows = useMemo(() => {
    if (!enabled) return [];

    const today = new Date();

    return (
      rows?.filter((data: any) => {
        if (data?.formatted?.PaymentDueAccountStatusId === "Paid") return false;

        const dueDate = new Date(data?.formatted?.DueDateDateOnly);

        if (filter === "Next 30 Days") {
          const next30 = new Date();
          next30.setDate(today.getDate() + 30);
          return dueDate >= today && dueDate <= next30;
        }

        if (filter === "Next 3 Months") {
          const next3Months = new Date();
          next3Months.setMonth(today.getMonth() + 3);
          return dueDate >= today && dueDate <= next3Months;
        }

        return true; // All Payments
      }) || []
    );
  }, [rows, enabled, filter]);

  const loadMoreRecords = () => {
    if (!enabled) return;
    if (!loading) fetchData(currentPage + 1);
  };

  const [sentryRef] = useInfiniteScroll({
    loading: enabled ? loading : false,
    hasNextPage: enabled ? hasMore : false,
    onLoadMore: enabled ? loadMoreRecords : () => {},
    rootMargin: "0px 0px 100px 0px",
  });

  return { filteredRows, loading, fetchData, sentryRef };
};
